module.exports = "https://static.wanderu.com/static/media/mashable.68f79d9f.png";